/** @prettier */
import cn from 'classnames';
import React from 'react';

import './style.pcss';
import BlurBlock from '../BlurBlock';

interface BlurBlockWrapperProps {
  show: boolean;
  currentBlock: any;
  children: React.ReactNode;
}

const BlurBlockWrapper: React.FC<BlurBlockWrapperProps> = ({
  show,
  currentBlock,
  children,
}: BlurBlockWrapperProps) => {
  return (
    <div
      className={cn(
        'blur-block-wrapper',
        `blur-block-wrapper--${show ? 'show' : 'unshow'}`
      )}
    >
      <div className='blur-block-wrapper__content'>{children}</div>
      <div className='blur-block-wrapper__blur-block'>
        <BlurBlock block={currentBlock} />
      </div>
    </div>
  );
};

export default BlurBlockWrapper;
